import { ActionIcon, Tooltip } from '@mantine/core';
import * as icons from '@sloyd/icons';
import classnames from 'classnames';
import { sendAnalytics } from '../../globals';
import { categories } from '../IconCategories/IconCategories.data';
import { Wrapper } from './MaterialCategoryPicker.style';

export type MaterialCategoryPickerProps = {
  value: string;
  onChange: (category: any) => void;
};

export function MaterialCategoryPicker(props: MaterialCategoryPickerProps) {
  const { value } = props;

  function onChange(item: Json) {
    if (item.id === value) {
      props.onChange('all');
      return;
    }
    props.onChange(item.id);
    sendAnalytics('Material Category Change', { value: item.id });
  }

  function renderIcon(item: any, index: number) {
    const Cmp = (icons as any)[item.icon];
    const position = index % 2 === 0 ? 'left' : 'right';
    const color = value === item.id ? 'gold' : '#889';

    return (
      <Tooltip key={item.id} label={item.title} position={position} openDelay={800}>
        <ActionIcon variant='subtle' key={item.id} className='icon' onClick={() => onChange(item)}>
          {Cmp && <Cmp stroke={1} color={color} />}
        </ActionIcon>
      </Tooltip>
    );
  }

  function renderIcons() {
    return categories
      .filter((c) => c.id !== 'all')
      .map((icon: any, index) => renderIcon(icon, index));
  }

  const className = classnames('MaterialCategoryPicker-wrapper', {});

  return (
    <Wrapper className={className} data-testid='MaterialCategoryPicker-wrapper'>
      {renderIcons()}
    </Wrapper>
  );
}

export default MaterialCategoryPicker;
